// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_pagination__7Mzat button, .style_pagination__7Mzat div {
  display: flex;
  align-items: center;
  justify-content: center;
}

.style_interface_heading_row__z\\+Mxv {
  display: flex;
  align-items: center;
}

.style_interface_noResults__nDDqx {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.style_interface__35LOd {
  display: flex;
  flex-direction: column;
}

a {
  text-decoration: none;
}

.style_link__jYWMy {
  cursor: pointer;
  color: #5c69f9;
}
.style_link__jYWMy:hover {
  text-decoration: underline;
}

.style_text-gradient-intel__Uc7dI {
  font-weight: bold;
  background: #CE4F8C;
  background: linear-gradient(to right, #CE4F8C 0%, #4720E2 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.style_text-xs__aRMqA {
  font-size: 0.75rem; /* 12px */
  line-height: 1rem; /* 16px */
}
.style_text-sm__NoINc, .style_interface_heading__NkxuM, .style_interface_footer__AiD9B {
  font-size: 0.875rem; /* 14px */
  line-height: 1.25rem;
}
.style_text-base__h9Mp3 {
  font-size: 1rem; /* 16px */
  line-height: 1.5rem; /* 24px */
}
.style_text-lg__bZNLE {
  font-size: 1.125rem; /* 18px */
  line-height: 1.75rem; /* 28px */
}
@media only screen and (max-width: 450px) {
  .style_text-lg__bZNLE {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
.style_text-xl__pwgi4 {
  font-size: 1.25rem; /* 20px */
  line-height: 1.75rem; /* 28px */
}
@media only screen and (max-width: 450px) {
  .style_text-xl__pwgi4 {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
.style_text-leading__4vM4W {
  line-height: 1.7rem;
}
@media only screen and (max-width: 450px) {
  .style_text-leading__4vM4W {
    line-height: 1.5rem;
  }
}

.style_breadcumb__Coxko {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 13px;
  color: var(--color-gray-400);
}
.style_breadcumb__Coxko a,
.style_breadcumb__Coxko span {
  padding: 3px 5px;
}
.style_breadcumb__Coxko a {
  text-decoration: none;
  transition: color 0.3s;
  border-radius: 5px;
}
.style_breadcumb__Coxko a:hover {
  color: var(--color-primary-500);
  background-color: var(--color-gray-800);
}
.style_breadcumb__Coxko .style_divider__Qaawh {
  color: var(--color-gray-400);
}

.style_badge__QruHt {
  width: max-content;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  font-size: 13px;
  color: white;
  gap: 5px;
  padding: 6px 9px;
}
.style_badge__QruHt.style_xs__TbZsP {
  padding: 3px 5px;
  font-size: 12px;
}
.style_badge__QruHt.style_sm__egxW7 {
  padding: 4px 7px;
}
.style_badge__QruHt.style_primary__lTTqb {
  background: var(--color-primary-500);
}
.style_badge__QruHt.style_primary__lTTqb, .style_badge__QruHt.style_pm__id0un {
  background: var(--color-primary-500);
}
.style_badge__QruHt.style_sd__incC0 {
  background-color: var(--color-secundary-500);
}
.style_badge__QruHt.style_Likely__nCpRh {
  background: var(--color-yellowdark-500);
  color: var(--color-yellowlight-300);
}
.style_badge__QruHt.style_Unvalidated__WS56l {
  background: var(--color-reddark-500);
  color: var(--color-redlight-300);
}
.style_badge__QruHt.style_Verified__H6TxM, .style_badge__QruHt.style_green__DYy8n {
  background-color: var(--color-greendark-500);
  color: var(--color-greenlight-300);
}
.style_badge__QruHt.style_off__ZFbXT {
  color: var(--color-white-500);
  background-color: var(--color-gray-700);
}

.style_badgeTable__VgUM- {
  width: max-content;
  border-radius: 8px;
  font-size: 13px;
  color: white;
  gap: 5px;
  padding: 6px 9px;
}
.style_badgeTable__VgUM-.style_xs__TbZsP {
  padding: 3px 5px;
  font-size: 12px;
}
.style_badgeTable__VgUM-.style_sm__egxW7 {
  padding: 4px 7px;
}
.style_badgeTable__VgUM-.style_primary__lTTqb, .style_badgeTable__VgUM-.style_pm__id0un {
  background: var(--color-primary-500);
}
.style_badgeTable__VgUM-.style_sd__incC0 {
  background-color: var(--color-secundary-500);
}
.style_badgeTable__VgUM-.style_Likely__nCpRh {
  background: #413e1a;
  color: #e6f979;
}
.style_badgeTable__VgUM-.style_Verified__H6TxM, .style_badgeTable__VgUM-.style_green__DYy8n {
  background-color: var(--color-greendark-500);
  color: var(--color-greenlight-300);
}
.style_badgeTable__VgUM-.style_off__ZFbXT {
  color: var(--color-white-500);
  background-color: var(--color-gray-700);
}

.style_table__Ml02D {
  border-collapse: collapse;
  width: 100%;
  table-layout: fixed;
}
.style_table__Ml02D.style_style-1__HjNgG td,
.style_table__Ml02D.style_style-1__HjNgG th {
  padding: 12px 1rem;
  font-size: 0.875rem;
}
.style_table__Ml02D.style_style-1__HjNgG th,
.style_table__Ml02D.style_style-1__HjNgG td.style_label__JYuVL {
  color: var(--color-white-500);
}
.style_table__Ml02D.style_style-1__HjNgG th {
  font-weight: normal;
  border-style: solid;
  border-color: var(--color-gray-100);
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.style_table__Ml02D.style_style-1__HjNgG tr.style_noBorder__\\+MoSC td {
  border-bottom: none;
}
.style_table__Ml02D.style_style-1__HjNgG tr td {
  color: var(--color-white-500);
}

.style_pagination__7Mzat {
  display: inline-flex;
  height: 38px;
  border: 1px solid var(--color-gray-700);
  border-radius: 8px;
  width: max-content;
  -webkit-user-select: none; /* Safari */ /* IE 10 and IE 11 */
  user-select: none;
}
.style_pagination__7Mzat button {
  text-shadow: 2px 2px 2px var(--color-gradient-black-500);
  padding: 0 10px;
  height: 100%;
  font-size: 15px;
  display: flex;
  color: var(--color-white-500);
  border-right: 1px solid var(--color-gray-700);
}
.style_pagination__7Mzat button:first-child {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}
.style_pagination__7Mzat button:last-child {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}
@media only screen and (max-width: 450px) {
  .style_pagination__7Mzat button {
    padding: 0 13px;
    font-size: 14px;
  }
}
.style_pagination__7Mzat button.style_disabled__y9TJU, .style_pagination__7Mzat button.style_active__5zB-N, .style_pagination__7Mzat button.style_info__KnHYf {
  cursor: pointer;
  pointer-events: none;
}
.style_pagination__7Mzat button.style_disabled__y9TJU {
  color: var(--color-gray-700);
}
.style_pagination__7Mzat div {
  text-shadow: 2px 2px 2px var(--color-gradient-black-500);
  padding: 0 10px;
  height: 100%;
  font-size: 15px;
  display: flex;
  color: var(--color-white-500);
  border-right: 1px solid var(--color-gray-700);
}
.style_pagination__7Mzat div:first-child {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}
.style_pagination__7Mzat div:last-child {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}
.style_pagination__7Mzat div:hover, .style_pagination__7Mzat div.style_active__5zB-N {
  cursor: pointer;
  background: linear-gradient(var(--color-paper-400), rgba(0, 0, 0, 0.9)) top/100% 500%;
}
@media only screen and (max-width: 450px) {
  .style_pagination__7Mzat div {
    padding: 0 13px;
    font-size: 14px;
  }
}
.style_pagination__7Mzat div.style_disabled__y9TJU, .style_pagination__7Mzat div.style_active__5zB-N, .style_pagination__7Mzat div.style_info__KnHYf {
  cursor: pointer;
  pointer-events: none;
}
.style_pagination__7Mzat div.style_disabled__y9TJU {
  color: var(--color-gray-700);
}
.style_pagination__7Mzat div:last-child, .style_pagination__7Mzat div:first-child {
  padding: 0 10px;
}
.style_pagination__7Mzat div:last-child {
  border-right: none;
}
.style_pagination__7Mzat button:last-child, .style_pagination__7Mzat button:first-child {
  padding: 0 10px;
}
.style_pagination__7Mzat button:last-child {
  border-right: none;
}

.style_interface__35LOd {
  width: 100%;
  border-radius: 10px;
  border-left: 2px solid var(--color-gray-800);
  border-right: 2px solid var(--color-gray-800);
  background-color: var(--color-gray-100);
  box-shadow: 0px 2px 11px 0px rgba(255, 255, 255, 0.1);
}
.style_interface_heading__NkxuM {
  gap: 15px;
  flex-direction: column;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 10px;
  border-radius: 8px 8px 0 0;
}
@media only screen and (max-width: 450px) {
  .style_interface_heading__NkxuM {
    padding: 12px 10px;
    align-items: flex-start;
  }
  .style_interface_heading__NkxuM > div {
    width: 100%;
  }
}
.style_interface_heading_row__z\\+Mxv {
  justify-content: space-between;
  width: 100%;
  gap: 15px;
}
@media only screen and (max-width: 450px) {
  .style_interface_heading_row__z\\+Mxv {
    flex-direction: column;
    align-items: flex-start;
  }
}
.style_interface_footer__AiD9B {
  gap: 15px;
  flex-direction: column;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 10px;
  border-radius: 0 0 8px 8px;
}
@media only screen and (max-width: 450px) {
  .style_interface_footer__AiD9B {
    padding: 12px 10px;
    align-items: flex-start;
  }
  .style_interface_footer__AiD9B > div {
    width: 100%;
  }
}
.style_interface_foot__ti7go {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
}
@media only screen and (max-width: 450px) {
  .style_interface_foot__ti7go {
    flex-direction: column;
    align-items: flex-start;
  }
}
.style_interface_noResults__nDDqx {
  gap: 15px;
  padding: 70px 0;
}

.style_popup__lMwo0 {
  background-color: var(--body-bg);
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
}
.style_popup__lMwo0 p {
  margin-bottom: 15px;
  max-width: none !important;
}
.style_popup__lMwo0 button {
  margin-top: 15px;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/_flex.scss","webpack://./src/components/molecules/AzureDownload(notused)/style.module.scss","webpack://./src/assets/scss/theme/_typography.scss","webpack://./src/assets/scss/_breakpoint.scss","webpack://./src/assets/scss/theme/_breadcumb.scss","webpack://./src/assets/scss/theme/_badge.scss","webpack://./src/assets/scss/theme/_table.scss","webpack://./src/assets/scss/theme/_pagination.scss","webpack://./src/assets/scss/theme/_global.scss","webpack://./src/assets/scss/theme/_interface.scss","webpack://./src/assets/scss/_colors.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;ACCF;;ADEA;EACE,aAAA;EACA,mBAAA;ACCF;;ADaA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;ACVF;;AD6BA;EACE,aAAA;EACA,sBAAA;AC1BF;;ACbA;EACI,qBAAA;ADgBJ;;ACdA;EACI,eAAA;EACA,cAAA;ADiBJ;AChBI;EACE,0BAAA;ADkBN;;ACdA;EACI,iBAAA;EACA,mBAAA;EACA,+DAAA;EACA,qBAAA;EACA,6BAAA;EACA,oCAAA;ADiBJ;;ACdI;EACI,kBAAA,EAAA,SAAA;EACA,iBAAA,EAAA,SAAA;ADiBR;ACfI;EACI,mBAAA,EAAA,SAAA;EACA,oBAAA;ADiBR;ACfI;EACI,eAAA,EAAA,SAAA;EACA,mBAAA,EAAA,SAAA;ADiBR;ACfI;EACI,mBAAA,EAAA,SAAA;EACA,oBAAA,EAAA,SAAA;ADiBR;AEzDE;EDsCE;IAIQ,eAAA;IACA,mBAAA;EDmBV;AACF;ACjBI;EACI,kBAAA,EAAA,SAAA;EACA,oBAAA,EAAA,SAAA;ADmBR;AEnEE;ED8CE;IAIQ,eAAA;IACA,mBAAA;EDqBV;AACF;ACnBI;EACI,mBAAA;ADqBR;AE5EE;EDsDE;IAGQ,mBAAA;EDuBV;AACF;;AG/EA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,4BAAA;AHkFF;AGjFE;;EAEE,gBAAA;AHmFJ;AGjFE;EACE,qBAAA;EACA,sBAAA;EACA,kBAAA;AHmFJ;AGlFI;EACE,+BAAA;EACA,uCAAA;AHoFN;AGjFE;EACE,4BAAA;AHmFJ;;AIvGA;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,QAAA;EACA,gBAAA;AJ0GF;AIvGE;EACE,gBAAA;EACA,eAAA;AJyGJ;AIvGE;EACE,gBAAA;AJyGJ;AIrGE;EACE,oCAAA;AJuGJ;AIrGE;EAEE,oCAAA;AJsGJ;AIpGE;EACE,4CAAA;AJsGJ;AIpGE;EACE,uCAAA;EACA,mCAAA;AJsGJ;AIpGE;EACE,oCAAA;EACA,gCAAA;AJsGJ;AIpGE;EAEE,4CAAA;EACA,kCAAA;AJqGJ;AInGE;EACE,6BAAA;EACA,uCAAA;AJqGJ;;AIlGA;EACE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,QAAA;EACA,gBAAA;AJqGF;AIlGE;EACE,gBAAA;EACA,eAAA;AJoGJ;AIlGE;EACE,gBAAA;AJoGJ;AIhGE;EAEE,oCAAA;AJiGJ;AI/FE;EACE,4CAAA;AJiGJ;AI/FE;EACE,mBAAA;EACA,cAAA;AJiGJ;AI/FE;EAEE,4CAAA;EACA,kCAAA;AJgGJ;AI9FE;EACE,6BAAA;EACA,uCAAA;AJgGJ;;AKxLA;EACE,yBAAA;EACA,WAAA;EACA,mBAAA;AL2LF;AKzLI;;EAEE,kBAAA;EACA,mBAAA;AL2LN;AKzLI;;EAEE,6BAAA;AL2LN;AKzLI;EACE,mBAAA;EACA,mBAAA;EACA,mCAAA;EACA,qBAAA;EACA,wBAAA;AL2LN;AKxLM;EACE,mBAAA;AL0LR;AKxLM;EACE,6BAAA;AL0LR;;AM9MA;EACI,oBAAA;EACA,YAAA;EAEA,uCAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA,EAAA,WAAA,EACA,oBAAA;EACA,iBAAA;ANgNJ;AM9MI;ELbA,wDAAA;EKgBI,eAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,6BAAA;EACA,6CAAA;AN+MR;AM9MQ;EACI,2BAAA;EACA,8BAAA;ANgNZ;AM9MQ;EACI,4BAAA;EACA,+BAAA;ANgNZ;AE/OE;EIgBE;IAkBQ,eAAA;IACA,eAAA;ENiNV;AACF;AMhNQ;EACI,eAAA;EACA,oBAAA;ANkNZ;AMhNQ;EACI,4BAAA;ANkNZ;AM/MI;EL1CA,wDAAA;EK6CI,eAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,6BAAA;EACA,6CAAA;ANgNR;AM/MQ;EACI,2BAAA;EACA,8BAAA;ANiNZ;AM/MQ;EACI,4BAAA;EACA,+BAAA;ANiNZ;AM/MQ;ECrCJ,eAAA;EACA,qFAAA;APuPJ;AEjRE;EI6CE;IAqBQ,eAAA;IACA,eAAA;ENmNV;AACF;AMlNQ;EACI,eAAA;EACA,oBAAA;ANoNZ;AMlNQ;EACI,4BAAA;ANoNZ;AMjNI;EACI,eAAA;ANmNR;AMjNI;EACI,kBAAA;ANmNR;AMjNI;EACI,eAAA;ANmNR;AMjNI;EACI,kBAAA;ANmNR;;AQrSA;EACE,WAAA;EACA,mBAAA;EACA,4CAAA;EACA,6CAAA;EACA,uCAAA;EAGA,qDAAA;ARwSF;AQtSE;EACE,SAAA;EACA,sBAAA;EACA,aAAA;EAEA,8BAAA;EAEA,mBAAA;EACA,kBAAA;EACA,0BAAA;ARuSJ;AE/TE;EMeA;IAWI,kBAAA;IACA,uBAAA;ERySJ;EQxSI;IACE,WAAA;ER0SN;AACF;AQxSI;EAEE,8BAAA;EACA,WAAA;EACA,SAAA;ARySN;AE7UE;EMgCE;IAMI,sBAAA;IACA,uBAAA;ER2SN;AACF;AQxSE;EACE,SAAA;EACA,sBAAA;EACA,aAAA;EAEA,8BAAA;EAEA,mBAAA;EACA,kBAAA;EACA,0BAAA;ARySJ;AE7VE;EM2CA;IAWI,kBAAA;IACA,uBAAA;ER2SJ;EQ1SI;IACE,WAAA;ER4SN;AACF;AQzSE;EACE,aAAA;EACA,yBAAA;EACA,SAAA;AR2SJ;AE3WE;EM6DA;IAKI,sBAAA;IACA,uBAAA;ER6SJ;AACF;AQ3SE;EAEE,SAAA;EACA,eAAA;AR4SJ;;AApXA;EACI,gCSCM;ETAN,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;AAuXJ;AArXI;EACI,mBAAA;EACA,0BAAA;AAuXR;AApXI;EACI,gBAAA;AAsXR","sourcesContent":["%flex-center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n%flex-align {\n  display: flex;\n  align-items: center;\n}\n\n%flex-stretch {\n  display: flex;\n  align-items: stretch;\n}\n\n%flex-align-start {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n%flex-column-align {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n}\n\n%flex-justify-center {\n  display: flex;\n  justify-content: center;\n}\n\n%flex-justify-between-center {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n%flex-justify-between {\n  display: flex;\n  justify-content: space-between;\n}\n\n%flex-column {\n  display: flex;\n  flex-direction: column;\n}\n\n%flex-column-center {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n%flex-column-center-reverse {\n  display: flex;\n  flex-direction: column-reverse;\n  align-items: center;\n  justify-content: center;\n}\n\n%flex-column-justify-center {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n%flex-align-end {\n  display: flex;\n  justify-content: flex-end;\n}\n\n%flex-start {\n  display: flex;\n  justify-content: flex-start;\n}\n\n%flex-column-align-start {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n%flex-align-start {\n  display: flex;\n  align-items: flex-start;\n}\n\n%flex-justify-evenly {\n  display: flex;\n  justify-content: space-evenly;\n}\n\n%flex-justify-evenly-center {\n  display: flex;\n  align-items: center;\n  justify-content: space-evenly;\n}\n\n%flex-column-justify-center {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}","@use \"../../../assets/scss/\" as *;\n\n.popup {\n    background-color: $body-bg;\n    color: white;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    text-align: center;\n    \n    p {\n        margin-bottom: 15px;\n        max-width: none!important;\n    }\n\n    button {\n        margin-top: 15px;\n    }\n}","@use \"../breakpoint\" as *;\n@use \"../colors\" as *;\n\n@mixin textShadow() {\n    text-shadow: 2px 2px 2px $color-gradient-black-500;\n}\n\na {\n    text-decoration: none;\n}\n.link {\n    cursor: pointer;\n    color: #5c69f9;\n    &:hover{\n      text-decoration: underline;\n    }\n}\n\n.text-gradient-intel {\n    font-weight: bold;\n    background: #CE4F8C;\n    background: linear-gradient(to right, #CE4F8C 0%, #4720E2 100%);\n    background-clip: text;\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n}\n.text {\n    &-xs {\n        font-size: 0.75rem; /* 12px */\n        line-height: 1rem; /* 16px */\n    }\n    &-sm {\n        font-size: 0.875rem; /* 14px */\n        line-height: 1.25rem;\n    }\n    &-base {\n        font-size: 1rem; /* 16px */\n        line-height: 1.5rem; /* 24px */\n    }\n    &-lg {\n        font-size: 1.125rem; /* 18px */\n        line-height: 1.75rem; /* 28px */\n        @include mobile {\n            font-size: 1rem;\n            line-height: 1.5rem;\n        }\n    }\n    &-xl {\n        font-size: 1.25rem; /* 20px */\n        line-height: 1.75rem; /* 28px */\n        @include mobile {\n            font-size: 1rem;\n            line-height: 1.5rem;\n        }\n    }\n    &-leading {\n        line-height: 1.7rem;\n        @include mobile {\n            line-height: 1.5rem; \n        }\n    }\n}","@mixin mobile {\n  @media only screen and (max-width: 450px) {\n    @content;\n  }\n}\n\n@mixin mobileH {\n  @media only screen and (max-height: 710px) {\n    @content;\n  }\n}\n\n@mixin tablet {\n  @media only screen and (max-width: 810px) {\n    @content;\n  }\n}\n\n@mixin middle {\n  @media only screen and (max-width: 576px) {\n    @content;\n  }\n}\n\n@mixin middleTablet {\n  @media only screen and (max-width: 780px) {\n    @content;\n  }\n}\n","@use \"../colors\" as *;\n// @use \"./typography\" as *;\n\n.breadcumb {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 13px;\n  color: var(--color-gray-400);\n  a,\n  span {\n    padding: 3px 5px;\n  }\n  a {\n    text-decoration: none;\n    transition: color 0.3s;\n    border-radius: 5px;\n    &:hover {\n      color: var(--color-primary-500);\n      background-color: var(--color-gray-800);\n    }\n  }\n  .divider {\n    color: var(--color-gray-400);\n  }\n}\n","@use \"../colors\" as *;\n@use \"./typography\" as *;\n\n.badge {\n  width: max-content;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  font-size: 13px;\n  color: white;\n  gap: 5px;\n  padding: 6px 9px;\n\n  // SIZES\n  &.xs {\n    padding: 3px 5px;\n    font-size: 12px;\n  }\n  &.sm {\n    padding: 4px 7px;\n  }\n\n  // COLORS\n  &.primary {\n    background: var(--color-primary-500);\n  }\n  &.primary,\n  &.pm {\n    background: var(--color-primary-500);\n  }\n  &.sd {\n    background-color: var(--color-secundary-500);\n  }\n  &.Likely {\n    background: var(--color-yellowdark-500);\n    color: var(--color-yellowlight-300);\n  }\n  &.Unvalidated {\n    background: var(--color-reddark-500);\n    color: var(--color-redlight-300);\n  }\n  &.Verified,\n  &.green {\n    background-color: var(--color-greendark-500);\n    color: var(--color-greenlight-300);\n  }\n  &.off {\n    color: var(--color-white-500);\n    background-color: var(--color-gray-700);\n  }\n}\n.badgeTable {\n  width: max-content;\n  border-radius: 8px;\n  font-size: 13px;\n  color: white;\n  gap: 5px;\n  padding: 6px 9px;\n\n  // SIZES\n  &.xs {\n    padding: 3px 5px;\n    font-size: 12px;\n  }\n  &.sm {\n    padding: 4px 7px;\n  }\n\n  // COLORS\n  &.primary,\n  &.pm {\n    background: var(--color-primary-500);\n  }\n  &.sd {\n    background-color: var(--color-secundary-500);\n  }\n  &.Likely {\n    background: #413e1a;\n    color: #e6f979;\n  }\n  &.Verified,\n  &.green {\n    background-color: var(--color-greendark-500);\n    color: var(--color-greenlight-300);\n  }\n  &.off {\n    color: var(--color-white-500);\n    background-color: var(--color-gray-700);\n  }\n}\n",".table {\n  border-collapse: collapse;\n  width: 100%;\n  table-layout: fixed;\n  &.style-1 {\n    td,\n    th {\n      padding: 12px 1rem;\n      font-size: 0.875rem;\n    }\n    th,\n    td.label {\n      color: var(--color-white-500);\n    }\n    th {\n      font-weight: normal;\n      border-style: solid;\n      border-color: var(--color-gray-100);\n      border-top-width: 1px;\n      border-bottom-width: 1px;\n    }\n    tr {\n      &.noBorder td {\n        border-bottom: none;\n      }\n      td {\n        color: var(--color-white-500);\n        // border-bottom: 1px solid var(--color-paper-400);\n      }\n    }\n  }\n}\n","@use \"../colors\" as *;\n@use \"../flex\" as *;\n@use \"../breakpoint\" as *;\n@use \"./global\" as *;\n@use \"./typography\" as *;\n\n.pagination {\n    display: inline-flex;\n    height: 38px;\n    // background-color: var(--color-paper-400);\n    border: 1px solid var(--color-gray-700);\n    border-radius: 8px;\n    width: max-content;\n    -webkit-user-select: none; /* Safari */\n    -ms-user-select: none; /* IE 10 and IE 11 */\n    user-select: none;\n    // @include boxShadow();\n    button {\n        @extend %flex-center;        \n        @include textShadow();\n        padding: 0 10px;\n        height: 100%;\n        font-size: 15px;\n        display: flex;\n        color: var(--color-white-500);\n        border-right: 1px solid var(--color-gray-700);\n        &:first-child {\n            border-top-left-radius: 8px;\n            border-bottom-left-radius: 8px;\n        }\n        &:last-child {\n            border-top-right-radius: 8px;\n            border-bottom-right-radius: 8px;\n        }\n        @include mobile {\n            padding: 0 13px;\n            font-size: 14px;\n        }\n        &.disabled, &.active, &.info {\n            cursor: pointer;\n            pointer-events: none;\n        }\n        &.disabled {\n            color: var(--color-gray-700);\n        }\n    }\n    div {\n        @extend %flex-center;        \n        @include textShadow();\n        padding: 0 10px;\n        height: 100%;\n        font-size: 15px;\n        display: flex;\n        color: var(--color-white-500);\n        border-right: 1px solid var(--color-gray-700);\n        &:first-child {\n            border-top-left-radius: 8px;\n            border-bottom-left-radius: 8px;\n        }\n        &:last-child {\n            border-top-right-radius: 8px;\n            border-bottom-right-radius: 8px;\n        }\n        &:hover, &.active {\n            @include bgHover(var(--color-paper-400));\n        }\n        @include mobile {\n            padding: 0 13px;\n            font-size: 14px;\n        }\n        &.disabled, &.active, &.info {\n            cursor: pointer;\n            pointer-events: none;\n        }\n        &.disabled {\n            color: var(--color-gray-700);\n        }\n    }\n    div:last-child, div:first-child {\n        padding: 0 10px;\n    }\n    div:last-child {\n        border-right: none;\n    }\n    button:last-child, button:first-child {\n        padding: 0 10px;\n    }\n    button:last-child {\n        border-right: none;\n    }\n}","@use \"../colors\" as *;\n@use \"../breakpoint\" as *;\n\n@mixin container($width: 'base', $padding-top: 40) {\n    padding-top: $padding-top+px;\n    padding-bottom: 80px;\n    margin: auto;\n    gap: 40px;\n\n    @if $width == 'base' {\n        // width: $container-width;\n    }\n    @else if $width == 'sm' {\n        width: 712px;\n    }\n    @include tablet {\n        gap: 25px;\n        width: 100%;\n        justify-content: space-between;\n        padding-top: 25px;\n        padding-bottom: 60px;\n        padding-left: 20px !important;\n        padding-right: 20px !important;\n    }\n}\n@mixin bgHover($bg: 'black', $opacity: 90%, $r: 0, $g: 0, $b: 0) {\n    cursor: pointer;\n    background: linear-gradient($bg, rgb($r $g $b / #{$opacity})) top/100% 500%;\n}\n@mixin boxShadow() {\n    -webkit-box-shadow: 4px 6px 5px 0px $color-gradient-black-200;\n    -moz-box-shadow: 4px 6px 5px 0px $color-gradient-black-200;\n    box-shadow: 4px 6px 5px 0px $color-gradient-black-200;\n}","@use \"../colors\" as *;\n@use \"../breakpoint\" as *;\n@use \"./global\" as *;\n@use \"../flex\" as *;\n@use \"./typography\" as *;\n\n.interface {\n  width: 100%;\n  border-radius: 10px;\n  border-left: 2px solid var(--color-gray-800); \n  border-right: 2px solid var(--color-gray-800);\n  background-color: var(--color-gray-100);\n  -webkit-box-shadow: 0px 2px 11px 0px rgba(255,255,255,0.1);\n  -moz-box-shadow: 0px 2px 11px 0px rgba(255,255,255,0.1);\n  box-shadow: 0px 2px 11px 0px rgba(255,255,255,0.1);\n  @extend %flex-column;\n  &_heading {\n    gap: 15px;\n    flex-direction: column;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    @extend .text-sm;\n    align-items: center;\n    padding: 15px 10px;\n    border-radius: 8px 8px 0 0;\n    @include mobile {\n      padding: 12px 10px;\n      align-items: flex-start;\n      > div {\n        width: 100%;\n      }\n    }\n    &_row {\n      @extend %flex-align;\n      justify-content: space-between;\n      width: 100%;\n      gap: 15px;\n      @include mobile {\n        flex-direction: column;\n        align-items: flex-start;\n      } \n    }\n  }\n  &_footer {\n    gap: 15px;\n    flex-direction: column;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    @extend .text-sm;\n    align-items: center;\n    padding: 15px 10px;\n    border-radius: 0 0 8px 8px;\n    @include mobile {\n      padding: 12px 10px;\n      align-items: flex-start;\n      > div {\n        width: 100%;\n      }\n    }\n  }\n  &_foot {\n    display: flex;\n    justify-content: flex-end;\n    gap: 15px;\n    @include mobile {\n      flex-direction: column;\n      align-items: flex-start\n    }\n  }\n  &_noResults {\n    @extend %flex-column-align;\n    gap: 15px;\n    padding: 70px 0;\n  }\n\n}","//Global colors\n$main-color: var(--main-color);\n$bg-color: var(--bg-color);\n$dark-bg: var(--dark-bg);\n$body-bg: var(--body-bg);\n$error-color: var(--error-color);\n\n$color-gradient-black-500: var(--color-gradient-black-500);\n$color-gradient-black-200: var(--color-gradient-black-200);\n\n//Gradient\n$gradient: var(--gradient);\n$gradient-border: var(--gradient-border);\n\n//text-colors\n$text-color-W: var(--text-color-W);\n\n//border\n$border: var(--border);\n\n//scrollbar\n$scrollbar-background: var(--scrollbar-background);\n$scrollbar-hover-color: var(--scrollbar-hover-color);"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pagination": `style_pagination__7Mzat`,
	"interface_heading_row": `style_interface_heading_row__z+Mxv`,
	"interface_noResults": `style_interface_noResults__nDDqx`,
	"interface": `style_interface__35LOd`,
	"link": `style_link__jYWMy`,
	"text-gradient-intel": `style_text-gradient-intel__Uc7dI`,
	"text-xs": `style_text-xs__aRMqA`,
	"text-sm": `style_text-sm__NoINc`,
	"interface_heading": `style_interface_heading__NkxuM`,
	"interface_footer": `style_interface_footer__AiD9B`,
	"text-base": `style_text-base__h9Mp3`,
	"text-lg": `style_text-lg__bZNLE`,
	"text-xl": `style_text-xl__pwgi4`,
	"text-leading": `style_text-leading__4vM4W`,
	"breadcumb": `style_breadcumb__Coxko`,
	"divider": `style_divider__Qaawh`,
	"badge": `style_badge__QruHt`,
	"xs": `style_xs__TbZsP`,
	"sm": `style_sm__egxW7`,
	"primary": `style_primary__lTTqb`,
	"pm": `style_pm__id0un`,
	"sd": `style_sd__incC0`,
	"Likely": `style_Likely__nCpRh`,
	"Unvalidated": `style_Unvalidated__WS56l`,
	"Verified": `style_Verified__H6TxM`,
	"green": `style_green__DYy8n`,
	"off": `style_off__ZFbXT`,
	"badgeTable": `style_badgeTable__VgUM-`,
	"table": `style_table__Ml02D`,
	"style-1": `style_style-1__HjNgG`,
	"label": `style_label__JYuVL`,
	"noBorder": `style_noBorder__+MoSC`,
	"disabled": `style_disabled__y9TJU`,
	"active": `style_active__5zB-N`,
	"info": `style_info__KnHYf`,
	"interface_foot": `style_interface_foot__ti7go`,
	"popup": `style_popup__lMwo0`
};
export default ___CSS_LOADER_EXPORT___;
